import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=c390ec7a&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c390ec7a",
  null
  
)

export default component.exports